<template>
  <div class="card p-4">
    <div class="text-center process mx-auto">
      <img width="218" height="150" class="mb-4" alt="uploading" :src="uploadingImage" />
      <h5 class="mb-4">
        {{ $t('global.importData.uploading') }}
      </h5>
      <!-- TODO: show filename when uploading file   -->
      <p v-if="false" class="my-3">
        {{ fileName }}
      </p>
      <div class="text-start">
        <McProgressBar height="8px" :value="percentage" />
        <div class="d-flex align-items-center justify-content-between mt-4">
          <span class="__filesize">{{ fileUploadedSize }} / {{ fileSize }} data</span>
          <span class="__percentage">{{ percentage }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadingImage from '@/assets/images/upload-in-progress.png'
import McProgressBar from '@/components/McProgressBar'
import { getDetail } from '@/services/rest-api/lib/customer/import'
import { removeCustomerImportIdFromLs } from '../lib/helper'

export default {
  components: {
    McProgressBar,
  },
  data() {
    return {
      fileSize: 0,
      fileUploadedSize: 0,
      percentage: 0,
      timer: null,
      fileName: '',
      uploadingImage,
    }
  },
  mounted() {
    this.pollData()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    pollData() {
      this.timer = setInterval(async () => {
        const res = await getDetail(this.$route.params.id)

        if (res.errors) {
          this.handleRedirect(() => {
            this.$router.push({ name: 'Master Customer' })
            this.$mcToast.error('Data tidak ditemukan')
          })
          return
        }

        this.percentage = Number(res.data.process_percentage.toFixed(0))
        this.fileSize = res.data.total_count
        this.fileUploadedSize = res.data.processed_count

        if (res.data.status === 'PROCESSING') return

        this.handleRedirect(() => {
          if (res.data.status === 'DONE') {
            this.$router.push({
              name: 'Master Customer Import Result',
              params: { id: this.$route.params.id },
            })
            return
          }

          this.$router.push({ name: 'Master Customer' })
          this.$mcToast.error('Unggah gagal')
        })
      }, 1000)
    },
    handleRedirect(cb) {
      removeCustomerImportIdFromLs()
      clearInterval(this.timer)

      setTimeout(cb, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
.process {
  max-width: 300px;
}

.__filesize {
  color: $teal-300;
}

.__percentage {
  color: $blue;
  font-size: 16px;
  font-weight: 600;
}
</style>
